import SignUpFormBottomLink from "features/sign-up/components/SignUpFormBottomLink";
import SignInWithOptionalPasswordForm from "features/sign-up/sign-in-form/components/SignInForm/SignInWithOptionalPasswordForm";

import { SignInCardCommonProps } from "../../../../SignInCardCommon";
import LoginHeader from "./LoginHeader";

type Props = Pick<
  SignInCardCommonProps,
  | "onSignInSuccess"
  | "prefilledEmail"
  | "loading"
  | "redirectAuthenticatedUserTo"
  | "headerMessage"
> & {
  linkToPasswordReset: string;
  onClickLoginAnotherWay: () => void;
};

export default function SignInWithOptionalPasswordCard({
  onClickLoginAnotherWay,
  onSignInSuccess,
  linkToPasswordReset,
  redirectAuthenticatedUserTo,
  prefilledEmail,
  loading,
  headerMessage
}: Props) {
  return (
    <SignInWithOptionalPasswordForm
      onSignInWithPasswordSuccess={onSignInSuccess}
      forgotPasswordLink={linkToPasswordReset}
      prefilledEmail={prefilledEmail}
      redirectAuthenticatedUserTo={redirectAuthenticatedUserTo}
      loading={loading}
    >
      {{
        heading: <LoginHeader headerMessage={headerMessage} />,
        alternativeLoginLink: (
          <SignUpFormBottomLink
            onBottomLinkClick={onClickLoginAnotherWay}
            bottomLinkText="Log in another way"
          />
        )
      }}
    </SignInWithOptionalPasswordForm>
  );
}
